import { z } from "zod";

import { isValidCNPJ } from "@modules/agreements/utils/isValidCNPJ";
import { currencyToNumber } from "@core/utils/masks";

export const referralSchema = () =>
  z.object({
    partner: z.number(),
    company_name: z.string().min(1),
    company_cnpj: z
      .string()
      .optional()
      .nullable()
      .refine((value) => !value || isValidCNPJ(value), {
        message: "CNPJ inválido",
      }),
    sales_value: z.preprocess(currencyToNumber, z.number().min(0).optional().nullable()),
    commission_percentage: z.coerce.number().min(0).max(100).optional().nullable(),
    agreement: z.number().optional().nullable(),
    notes: z.string().optional().nullable(),
  });

export type ReferralFormValues = z.infer<ReturnType<typeof referralSchema>>;
